<template>
<div id="failed" class="modal mtn" style="z-index: 1003; display: block; opacity: 1; top: 6%; transform: scaleX(1) scaleY(1); min-height:350px; position: absolute; margin-bottom:6%;">
    <div class="modal-content">
        <a v-if="client_info.colors !== undefined" class=""  @click.prevent="tryAgain">
            <span class="back"  @click.prevent="tryAgain">
                <img src="/mtn/assets/back.svg" alt="">
            </span>
        </a>
        <h4></h4>
        <div class="row fail">
            <img src="/mtn/assets/failed.png" alt="" class="confirmimagefailed" style="margin-left: auto; margin-right: auto;">
            

            <div v-if="request_type !== null">
                <p class="payment-failed" style="width: 100%;" v-if="request_type.toLowerCase() == 'collect'" >Payment not Successful</p>
                <p class="payment-failed" style="width: 100%;" v-else-if="request_type.replace('_', ' ').toLowerCase() == 'buy airtime' || $store.state.payload.request_type.toLowerCase() === 'buy_airtime'" >Airtime Purchase not Successful</p>
            </div>
            <p v-else class="payment-failed" style="width: 100%;" > Transaction not Successful</p>
            

            <p class="pay-date" style="width: 100%;">{{date}}</p>

            <div v-if="hasMessage" class="transaction-det">
                <p class="tran-id-hd">Error Message</p>
                <p class="transaction-code" v-if="hasMessage" v-html="message"></p>
                <p class="transaction-code" v-else>Your Transaction has been Declined</p>

            </div>

            <div v-if="  client_info.colors !== undefined " >
                <a @click.prevent="tryAgain" class="submit failedsb">Choose another payment method</a>
                <button @click.prevent="continueToMerchant" class=" viabutton submit" style="margin-top:20px;">
                    {{ client_info.merchant && client_info.merchant.return_text ? client_info.merchant.return_text :  'Back to merchant'}}
                </button>
            </div>
            <button v-else @click.prevent="closeIframe" class="submit failedsb">Close</button>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Warning',
    created() {
        this.hasMessage = true;

        try {
            // console.log(this.$store.state)
            if (window.failedFromStart) {
                this.failedFromStart = window.failedFromStart;
            }

            if (window.failedFromStartMessage) {
                this.message = window.failedFromStartMessage
            }

            if (this.$store.state.client_info)
                this.client_info = this.$store.state.client_info;

            if (this.client_info == 'null' || this.client_info !== null)
                if (typeof this.client_info.colors != "undefined" || typeof this.client_info.colors == 'object') {
                    this.style = {
                        background: this.client_info.colors.primary_button ? this.client_info.colors.primary_button + ' !important' : appColor,
                        color: this.client_info.colors.payment_description ? this.client_info.colors.payment_description + '!important' : ''
                    }

                    if (window.raw && JSON.parse(window.raw).status) {
                        var res = JSON.parse(window.raw)

                        this.hasMessage = true;
                        this.message = res.message;

                        if (this.client_info && this.client_info !== null && this.client_info.colors)
                            this.appColor = this.client_info.colors.app + " !important" || this.client_info.colors.primary_button + " !important";
                        else {
                            this.appColor = 'grey'
                        }

                    }
                }
        } catch (e) {
            console.log(e)
        }

    },
    data() {
        return {
            date: '',
            status: 'Failed',
            hasMessage: false,
            message: '',
            appColor: '',
            style: {},
            client_info: '',
            request_type: null,
            env: false,
            failedFromStart: '',
        }
    },
    mounted() {
        this.date = this.$todaysDate();
        // console.log(window.raw);
        if(window.raw){
            const response = JSON.parse(window.raw);
            if(response.status){
                this.status = response.status;
            }
            // console.log(response);
        }
        this.request_type = this.$store.state.payload.request_type;
    },
    methods: {
        cancel() {
            this.closeIframe();
        },
        tryAgain() {
            // get initial trans ref and append few digits to it
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef(4)}`; 
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            this.$router.replace('/v2/mtn/popup').catch(err => {});
        },

        continueToMerchant() {
            let referrer = this.$store.state.popupReferrer

            if (!window.raw) {
                var response = {
                    status: 'Failed',
                    message: this.message || "Could not locate errors",
                    data: null,
                }
            } else {
                var res = JSON.parse(window.raw)
                res && res.data ? delete res.data.client_info : '';
                res && res.data ? delete res.data.paymentoptions : '';

                //
                let provider;
                if (this.$store.state.showDefaultView) {
                    if (this.$store.state.payload.transaction.options && this.$store.state.payload.transaction.options.default_view) {
                        provider = this.$store.state.payload.transaction.options.default_view.provider;
                        res.data.provider = provider;
                    }
                }

                var response = {
                    status: res ? res.status || "Failed" : "Failed",
                    message: this.message || (res && res.data ? res.data.message : 'No message from the server') || "Could not locate errors",
                    data: res && res.data ? res.data || null : null,
                }
            }

            if (this.$store.state.isFailed)
                response.parentTransRef = this.$store.state.parentTransRef

            if (window.failedFromStart == 'false') {
                response.reference = this.$store.state.transRef || null;
                response.optionsTransRef = this.$store.state.options.optionsTransRef || null;
                response.paymentmethod = this.$store.state.paymentMethod || null;
            }

            this.$store.replaceState({
                paymentMethod: '',
                paymentMethodIndex: '',
                client_info: {},
                service_call_payload: {},
                payload: {},
                options: {},
                api_key: null,
                isFailed: false,
                hasPaid: false,
                hasOtp: false,
                isLoading: true,
                channels: {},
                popupReferrer: null,
                provider: {},
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                parentTransRef: '',
                optionsTransRef: '',
                showDefaultView: false,
                transRef: '',
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: '',
                }
            });

            if (this.$route.name !== 'mtn-popup-v2')
                this.$router.push('/v2/mtn/popup').catch(err => {});

            response.status = "Failed";
            this.client_info = null;
            window.parent.postMessage(JSON.stringify(response), referrer && referrer.includes("file://") ? "*" : referrer);
        },
        
        closeIframe() {
            this.$store.replaceState({
                paymentMethod: '',
                paymentMethodIndex: '',
                client_info: {},
                service_call_payload: {},
                payload: {},
                options: {},
                api_key: null,
                isFailed: false,
                hasPaid: false,
                hasOtp: false,
                isLoading: true,
                channels: {},
                popupReferrer: null,
                provider: {},
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                parentTransRef: '',
                optionsTransRef: '',
                showDefaultView: false,
                transRef: '',
                mPGSCardUsed:{},
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: '',
                }
            });

            if (this.$route.name !== 'mtn-popup-v2')
                this.$router.push('/v2/mtn/popup');

            if (isIframe)
                window.parent.postMessage('close', '*');
            else
                console.log("Can only close in an iframe");

        }
    }
};
</script>

